<template>
 <div>{{ActDescBtn}}
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-96"  :max-height="this.windowSize.height-96" >
   <tr height="48px" max-height="48px">

        <ContenidoBase :EstadoBtn="EstadoBtn" :descripcion="'Utilitario Contabilidad'" :titulo="'Utilitario Contabilidad'"
                       @MethodAnular="anular" @MethodEliminar="remove" @MethodGuardar="save"
                       @MethodImprimir="imprimirList"
                       @MethodNuevo="newwnuevo" @abrirBarraTablaDinamica="abrirTabla" />
      </tr>
  <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraPrimariaAbrir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitUtilitarioRecIng'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>




      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 

 <div class="px-2">
  <v-card color="grey lighten-3">
  <div class="px-2" style="border: 1px solid #000000;">
  <v-form ref="formContabilidad" @submit.prevent=""  v-model="valid" lazy-validation>
    
<!-- row 1  ---------------------------------------->
<v-row>

<!-- <v-switch
              class="mt-0"
              v-model="UtilitarioContabBusqueda.itbis"
              label="Activo"
              color="success"
              hide-detail

              >

        <template v-slot:label>
         <strong v-if="UtilitarioContabBusqueda.itbis==true"  style="color:#000000; font-size: 13px; ">Activo: Si</strong>
         <strong v-if="UtilitarioContabBusqueda.itbis==false" style="color:#000000; font-size: 13px; ">Activo: No</strong>
        </template>
              
</v-switch> -->


<v-col cols="12" md="3" sm="3">
<v-tooltip top>
<template v-slot:activator="{ on }"> 
   
  <v-text-field
          v-on="on"
        dense
        outlined
        type="date"  
        label="Fecha Inicial"
        v-model="UtilitarioContabBusqueda.fechaInicial"
        :rules="[$rules.required]"
        placeholder=" "
        style="font-size: 12px;"  
        @input="getContabilida" 
        v-on:input="resertPaginacion"
        @blur="BlurfecInic"
        >
                <template v-slot:prepend>
                  <i style="font-size: 18px;" class="fa fa-calendar"></i>
                </template>
  </v-text-field>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
    </i>   
  </v-tooltip>
</v-col>

<v-col cols="12" md="3" sm="3">

<v-tooltip top>
<template v-slot:activator="{ on }"> 
<v-text-field
v-on="on"
        dense
        outlined
        type="date"  
        label="Fecha Final"
        v-model="UtilitarioContabBusqueda.fechaFinal"
        :rules="[$rules.required]"
        placeholder=" "
        style="font-size: 12px;"  
        @input="getContabilida" 
        v-on:input="resertPaginacion"
        @blur="BlurfecFinal"

        >
                <template v-slot:prepend>
                  <i style="font-size: 18px;" class="fa fa-calendar"></i>
                </template>
</v-text-field>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
    </i>   
  </v-tooltip>
</v-col>


<v-col cols="12" md="6" sm="6">

<v-tooltip top>
<template v-slot:activator="{ on }"> 
  <!-- item => `${item.codigo} - ${item.modulo.trim()} - ${item.nombre.trim()}`-->
  <!-- @change="getContabilida" -->
  <v-combobox
      v-on="on"
            v-model="UtilitarioContabBusqueda.documento"
            autocomplete="off"
            dense
            outlined
            label="Documentos:"
            :items="filterDocOperacion(RDocumento)"
            :filter="filterCombDocumento"
            
            item-text="codnom"
            clearable
            @blur="SelctCbDocumento"
            @focus="cargarDocumento"
            style="font-size: 13px;"
            v-on:change="resertPaginacion"
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-book"></i>
            </template>
        
            <template v-slot:selection="{ attrs, item, parent, selected }">
             <span class="fontSize13 colorNombre"><b>{{ item.hasOwnProperty("codigo") && item.codigo!=null?item.codigo:"" }}</b> - {{item.hasOwnProperty("modulo") &&  item.modulo!=null? item.modulo.trim():""}} - {{ item.hasOwnProperty("nombre")&& item.nombre !=null? item.nombre.trim():""}}</span>
            </template>

            <template slot="item" slot-scope="item">
                  <span style="display:none;">{{ item.item.codnom = `${item.item.hasOwnProperty("codigo") && item.item.codigo!=null?item.item.codigo:""} - ${item.item.hasOwnProperty("modulo") &&  item.item.modulo!=null? item.item.modulo.trim():""} - ${item.item.hasOwnProperty("nombre")&& item.item.nombre !=null? item.item.nombre.trim():""}` }}</span>
                  <span class="fontSize13"><b>{{ item.item.hasOwnProperty("codigo") && item.item.codigo!=null?item.item.codigo:"" }}</b> - {{item.item.hasOwnProperty("modulo") &&  item.item.modulo!=null? item.item.modulo.trim():""}} - {{ item.item.hasOwnProperty("nombre")&& item.item.nombre !=null? item.item.nombre.trim():""}}</span>
            </template> 

          </v-combobox>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se registra el documento  de la contabilidad  que se desea buscar.</span>
    </i>   
  </v-tooltip>

</v-col>

</v-row>
<!-- fn row 1  ---------------------------------------->

<!-- fn row 2  ---------------------------------------->

<v-row style="margin-top:-25px;">
  <v-col cols="12" md="3" sm="3">

<v-tooltip top>
<template v-slot:activator="{ on }"> 

<v-text-field
            v-on="on"
            label="# Secuencia:"
            dense
            autocomplete="off"
            outlined
            type="number"
            v-model.number="UtilitarioContabBusqueda.NoSecuencia"
            @blur="getContabilida"
            v-on:input="resertPaginacion"

            style="font-size: 13px;"
          >

          
            <template v-slot:prepend>
              <i  style="font-size: 20px;" class="fa fa-hashtag"></i>
            </template>
</v-text-field>


 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
   <span> Aquí se registra el  número contable que deseamos búscar.</span>
 </i>   

  </v-tooltip> 
</v-col>

<v-col cols="12" md="6" sm="6">
  <!-- item-text="descripcion" -->
<v-tooltip top>
<template v-slot:activator="{ on }"> 
<!-- item => `${item.codigo} - ${item.modulo.trim()} - ${item.descripcion.trim()}` -->
<v-combobox v-on="on"
                   id="ImputColorDisable"
                    v-model="UtilitarioContabBusqueda.operacion"
                    label="* Operación:" outlined dense
                  autocomplete="off"
                  :items="ROperacion"
                   :filter="filterComb"
                   item-text="codnom"
                    @blur="SelctCbOperacion"
                    @focus="CargarROperacion"
                    style="font-size: 13px;"
                    @change="getContabilida"
                    :disabled="disableOpera"
                    clearable
                  >  

    <template v-slot:prepend>
                            <i style="font-size: 20px;" class=" fa fa-line-chart" ></i>
                          </template>

           <template v-slot:selection="{ attrs, item, parent, selected }">
             <span class="fontSize13 colorNombre"><b>{{ item.hasOwnProperty("codigo") && item.codigo!=null?item.codigo:"" }}</b> - {{item.hasOwnProperty("modulo") &&  item.modulo!=null? item.modulo.trim():""}} - {{ item.hasOwnProperty("descripcion")&& item.descripcion !=null? item.descripcion.trim():""}}</span>
            </template>

            <template slot="item" slot-scope="item">
                  <span style="display:none;">{{ item.item.codnom = `${item.item.hasOwnProperty("codigo") && item.item.codigo!=null?item.item.codigo:""} - ${item.item.hasOwnProperty("modulo") &&  item.item.modulo!=null? item.item.modulo.trim():""} - ${item.item.hasOwnProperty("descripcion")&& item.item.descripcion !=null? item.item.descripcion.trim():""}` }}</span>
                  <span class="fontSize13"><b>{{ item.item.hasOwnProperty("codigo") && item.item.codigo!=null?item.item.codigo:"" }}</b> - {{item.item.hasOwnProperty("modulo") &&  item.item.modulo!=null? item.item.modulo.trim():""}} - {{ item.item.hasOwnProperty("descripcion")&& item.item.descripcion !=null? item.item.descripcion.trim():""}}</span>
            </template> 




<!-- <template v-slot:selection="{ attrs, item, parent, selected }">
            <span id="ImputColorDisable" >
            {{ item.descripcion }}
          </span>

</template>

                      

 <template slot="item" slot-scope="item" margin-top="50px">
 <v-row>
 <v-col cols="9" md="9"> <span style="font-size: 14px;">{{ item.item.descripcion}}</span> </v-col>
 <v-col cols="3" md="3"> <span style="font-size: 14px;"> {{item.item.modulo }}</span> </v-col>
 </v-row>
 </template>

 <template v-slot:prepend-item>
                  <v-row>
                  
                  <v-col cols="9" md="9" > <b style="font-size: 16px;">Descripción: </b> </v-col>
                  <v-col cols="3" md="3" > <b style="font-size: 16px;">Modulo:</b> </v-col>
                 </v-row>
  </template> -->





</v-combobox>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
   <span> Aquí se registra la  operacion  que deseamos búscar.</span>
 </i>   

  </v-tooltip> 
</v-col>

<v-col cols="12" md="3" sm="3">

<v-tooltip top>
<template v-slot:activator="{ on }">
   
<v-btn id="boton-mini"  :disabled="Generarloading"  rounded v-on="on" @click.prevent="GenerarContabilidad" color="teal" >
<i style="font-size: 20px;" class="fa fa-retweet"></i><!-- fab x-small dark  -->
Generar</v-btn>


 </template>
          <span>Generar contabilidad</span>
  </v-tooltip>

</v-col>
</v-row>

<!-- fn row 2  ---------------------------------------->

</v-form>



<v-row>

 <v-col cols="12" md="12" sm="12" style="margin-top:-25px;" >
  <div style="border: 1px solid #000000;" >

<!-- @click:row="datostabla" -->
 <v-data-table

      class="RowSelectColor"
      :single-select="true"
      item-key="indx"
      :show-select="true"
      v-model="selected"
       @item-selected="obtenerDatoSelect"

      :headers="[
              { text: 'Documento', sortable: false, value: 'descdocumento', width:'auto',class: ['no-gutters black--text'] },
                { text: 'Secuencia', sortable: false,  value: 'secuencia', width:'auto',class: ['no-gutters black--text']  },
                 { text: 'fecha', sortable: false, value: 'fecha', width:'auto',class: ['no-gutters black--text']  },
                 { text: 'Ref.', sortable: false, value: 'referencia', width:'auto',class: ['no-gutters black--text']  },
                 { text: 'Operacion', sortable: false, value: 'operaciones.descripcion', width:'auto',class: ['no-gutters black--text']  },
                 { text: 'Activo', sortable: false, value: 'activo', width:'auto', width:'auto',class: ['no-gutters black--text']  },
                 { text: 'Acción', sortable: false, value: 'acciones', width:'auto', width:'auto',class: ['no-gutters black--text']  },
                 
                 ]"

              dense
              @click:row="datostabla"
              :items="ListContabilidad"
              @pagination="cargarPaginacion"
              :items-per-page="paginator.itemsPerPage"
              :server-items-length="TotalRegistros"
              v-if="resertPagi==true"      
            :footer-props="$arrayPropiedasesGlobal""
            >

  

<!-- size="8" @keyup="KeyUpCantidad"  -->

<template v-slot:item.fecha="props">
<span style="font-size:13px; display:none;">{{props.item.indx = ListContabilidad.indexOf(props.item)}}</span>
  <span style="font-size:13px;">{{FormatoFecha(props.item.fecha)}}</span>
 </template>


<template v-slot:item.activo="props"> 
   <span v-if="props.item.activo==true"  style="color:#000000; font-size: 13px; ">Si</span>
  <span v-if="props.item.activo==false" style="color:#000000; font-size: 13px; ">No</span>
 </template>

 <template v-slot:item.acciones="{ item }">
                            <v-btn color="red" rounded small @click="eliminarContabilidad(item)">
                              <i class="fa fa-trash" style="font-size: 20px; "></i>
                            </v-btn>
                          </template>

 </v-data-table>


  </div>
  </v-col>
   
              </v-row> 
  </div>
  </v-card>
<hr>
<v-card color="grey lighten-3">
  <div class="px-2" style="border: 1px solid #000000;">

 <v-form ref="formContb" v-model="valid" lazy-validation>
                <input
                  type="number"
                  v-model="Utcontab.id"
                  style="display:none;"
                />

<!-- Rows 1----------------------------->
                <v-row>

<v-col cols="12" md="6" sm="6">
<v-tooltip top>
<template v-slot:activator="{ on }"> 
  <v-combobox
    id="ImputColorDisable"
      v-on="on"
            v-model="Utcontab.descdocumento"
            autocomplete="off"
            dense
            outlined
            label="Documentos:"
            style="font-size: 13px;"
            disabled
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-book"></i>
            </template>
          </v-combobox>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se Muestra el documento  de la contabilidad.</span>
    </i>   
  </v-tooltip>
</v-col>

<v-col cols="12" md="3" sm="3">

<v-tooltip top>
<template v-slot:activator="{ on }"> 

<v-text-field
            id="ImputColorDisable"
            v-on="on"
            label="# Secuencia:"
            dense
            autocomplete="off"
            outlined
            type="number"
            v-model.number="Utcontab.secuencia"
            @blur="getContabilida"
            v-on:input="resertPaginacion"
            disabled

            style="font-size: 13px;"
          >
            <template v-slot:prepend>
              <i  style="font-size: 20px;" class="fa fa-hashtag"></i>
            </template>
</v-text-field>


 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
   <span> Aquí se registra el  número contable que deseamos búscar.</span>
 </i>   

  </v-tooltip> 
</v-col>

<v-col cols="12" md="3" sm="3">
<v-tooltip top>
<template v-slot:activator="{ on }"> 
   
  <v-text-field
          v-on="on"
        dense
        outlined
        type="date"  
        label="Fecha"
        v-model="Utcontab.fecha"
        :rules="[$rules.required]"
        placeholder=" "
        style="font-size: 12px;"  
        @input="getContabilida" 
        v-on:input="resertPaginacion"
        >
                <template v-slot:prepend>
                  <i style="font-size: 18px;" class="fa fa-calendar"></i>
                </template>
  </v-text-field>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se Muestra la fecha del registro.</span>
    </i>   
  </v-tooltip>
</v-col>
 </v-row>
<!-- fn Rows 1----------------------------->

<!-- fn Rows 2----------------------------->
<v-row style="margin-top:-25px">
<v-col cols="12" md="6" sm="6">

<v-tooltip top>
<template v-slot:activator="{ on }"> 

<v-combobox v-on="on"
                id="ImputColorDisable"
                    v-model="Utcontab.operaciones"
                    label="* Operación:"
                    required
                    outlined
                    dense
                    
                    autocomplete="off"
                    :items="ROperacion"
                    item-text="descripcion"
                    @blur="SelctCbOperacion"
                    @focus="CargarROperacion"
                    style="font-size: 13px;"
                    @change="getContabilida"
                    disabled
                  >  
                          <template v-slot:prepend>
                            <i
                              style="font-size: 20px;"
                              class=" fa fa-line-chart"
                            ></i>
                          </template>


 <template slot="item" slot-scope="item" margin-top="50px">
 <v-row>
 <v-col cols="9" md="9"> <span style="font-size: 14px;">{{ item.item.descripcion}}</span> </v-col>
 <v-col cols="3" md="3"> <span style="font-size: 14px;"> {{item.item.modulo }}</span> </v-col>
 </v-row>
 </template>

 <template v-slot:prepend-item>
                  <v-row>
                  
                  <v-col cols="9" md="9" > <b style="font-size: 16px;">Descripción: </b> </v-col>
                  <v-col cols="3" md="3" > <b style="font-size: 16px;">Modulo:</b> </v-col>
                 </v-row>
          </template>


</v-combobox>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
   <span> Aquí se registra la  operacion  que deseamos búscar.</span>
 </i>   

  </v-tooltip> 
</v-col>

<v-col cols="12" md="6" sm="6">

<v-tooltip top>
<template v-slot:activator="{ on }" > 

  <!-- ----------------------------- Referencia -->
                
                    <v-text-field label="Referencia:"
                    autocomplete="off"
                     dense outlined
                     v-model="Utcontab.referencia"
                     v-on="on"
                     style="font-size: 13px;"
                     >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-map-signs"></i> 
                      </template>
                    </v-text-field>
 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
   <span>Se Muestra la Referencia .</span>
 </i>   

  </v-tooltip> 
 </v-col>
</v-row>
<!-- fn Rows 2----------------------------->


<!-- Rows 3 ----------------------------->
<v-row style="margin-top:-25px;">
<v-col cols="12" md="6" sm="6">

<v-tooltip top>
<template v-slot:activator="{ on }" > 
<!------------------------------- comentario -->
                  <v-textarea
                  v-on="on"
                  autocomplete="off"
                    label="comentario:"
                    dense
                    outlined
                    v-model="Utcontab.comentario"
                    rows="1"
                    style="font-size: 13px;"
                    
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-commenting"></i>
                    </template>
                  </v-textarea>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
   <span>Se Muestra la comentario.</span>
 </i>   

  </v-tooltip>

</v-col>


<v-col cols="12" md="6" sm="6">

<v-tooltip top>
<template v-slot:activator="{ on }" > 

  <v-switch
  v-on="on"
              class="mt-0"
              v-model="Utcontab.activo"
              label="Activo"
              color="success"
              hide-detail
              dense

              >

        <template v-slot:label>
         <strong v-if="Utcontab.activo==true"  style="color:#000000; font-size: 13px; ">activo: Si</strong>
         <strong v-if="Utcontab.activo==false" style="color:#000000; font-size: 13px; ">activo: No</strong>
        </template>
              
</v-switch>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
   <span>Se Muestra el estado.</span>
 </i>   

  </v-tooltip>

</v-col>


</v-row>
<!-- fn Rows 3 ----------------------------->
</v-form>


<v-col cols="12" sm="12" md="12">
<CuentasContablesExtra
@CuentasContables="CCuentasContables"
:RLisCuenta="RLisCuenta"
:Total="TotalCuenta"
/>


</v-col>


</div>
</v-card>
</div>

        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>




<v-dialog  v-model="dialogReporte"  persistent fullscreen hide-overlay transition="dialog-bottom-transition" >
  
<v-card>  
    <v-toolbar dark color="grey darken-2">

      <v-tooltip bottom >
<template v-slot:activator="{ on }">

  <v-toolbar-title v-on="on">
            Imprecion de reporte
  </v-toolbar-title>

 </template  >
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
  <span >  Imprecion: </span> Vista e Imprecion del reporte</i>

  </v-tooltip>

            <!-- <v-toolbar-title>Ordenes De Compras sugeridas</v-toolbar-title> -->

            <v-spacer></v-spacer>


      <v-btn
          color="grey darken-4"
          fab
          small
          @click="NewReporte"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn>
    </v-toolbar>

<v-list three-line subheader>
<pdf-app style="height: 100vh;" :pdf="pdf" :config="config"></pdf-app>

</v-list>
</v-card>
</v-dialog>







<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../event-bus";
import BarraBusqueda2 from "../components/BarraBusquedaDinam";
import ContenidoBase from "../components/ContenidoBase"
import VueAutonumeric from "../components/AutoNumericNuevo";
import VueAutonumericBasic from "../components/VueAutonumeric";
import CuentasContablesExtra from "@/UtilidadComponents/CuentasContablesExtra.vue";
import { currencyFormatter, FormatoFecha, getParamFecha, HoraFormatter,fechaNueva,RedondeoValor,
  RedondeoValorCantRed } from "@/js/Funciones.js"
export default {

  components: {
    ContenidoBase,
    BarraBusqueda2,
    VueAutonumeric,
    CuentasContablesExtra,
    VueAutonumericBasic,
    PdfApp: window["pdf-viewer"]
  },


  created() {


    var json = {
      titulo: "Utilitario Contabilidad",
      descripcion: "Utilitario Contabilidad",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: true,
      imprimir: false,
      btnBarraDi:false,
      recalcular:false,
      accion: [ 
        "UtilitarioContabilidadNew",
        "UtilitarioContabilidadSave",
        "UtilitarioContabilidadRemove",
        "UtilitarioContabilidadAnular",
        "UtilitarioContabilidadPrintList",
        "UtilitarioContabilidadVercuenta",
        "UtilitarioContabilidadCorreo",
        "UtilitarioContabilidadRecalcular"
        
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("UtilitarioContabilidadNew", this.new);
    EventBus.$on("UtilitarioContabilidadSave", this.save);
    EventBus.$on("UtilitarioContabilidadRemove", this.remove);
    EventBus.$on("UtilitarioContabilidadAnular", this.remove);
    EventBus.$on("UtilitarioContabilidadPrintList", this.imprimirList);
    EventBus.$on("emitUtilitarioContabilidad", this.datostabla);
    EventBus.$on("UtilitarioContabilidadRecalcular", this.Recalcular);
    this.cargarTodo();
    this.getContabilida()
    EventBus.$on("onResize", this.onResize);
  },

  data:()=>  ({
searchComb:null,
selected:[],

windowSize:{width:"auto", height:"auto"},
 config: { findbar: false },
 pdf: "",

RComprobantes:[],
ROperacion:[],

disableAll:false,
disableOpera:false,
dialogReporte:false,

      Rpropietario:[],
      RDocumento:[],
      RtipoComprobante:[],

      
  ejecucion:true,
  Generarloading:false,

       Totales:{totalHora:0},

       TotalCuenta:{
          credito:0,
          debito:0
        }, 

        RLisCuenta:[],
      


       RTipo:[
{codigo:1, descripcion:"Valor"},
{codigo:2, descripcion:"Porcentaje"},
],

RPagosAnticipado:[
{p:'Arros', e:'5',c:'200'},
{p:'aguacate', e:'15',c:'100'},
{p:'guineo', e:'25',c:'50'},
{p:'papa', e:'50',c:'80'},
{p:'pera', e:'60',c:'90'}

],



      ListaTiposClientes: [],
      ListContabilidad:[],

      TotalRegistros: 1,
      resertPagi:true,
      paginator: {
        itemsPerPage: 15,
        pageStart: 1,
        page: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5
      },

   Descdocumento:'',   

Utcontab:{
id: 0,
activo:true,
comentario: "",
documento: 1,
fecha: new Date().toISOString().substr(0,10),
operaciones: null,
referencia: "",
secuencia: 0,
descdocumento:''

},



  UtilitarioContabBusqueda: {
   documento:null,
   tipocomprobante:null,
   fechaInicial: new Date().toISOString().substr(0,10),
   fechaFinal: new Date().toISOString().substr(0,10),
   NoSecuencia:0,
   operacion:null,
        //fechaCreacion: new,
      //  fechaModificacion: "", 
      },

     
      EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },
      text: "",
      valid: true,
     BarraPrimariaAbrir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },


  methods: {

currencyFormatter, FormatoFecha, getParamFecha, HoraFormatter,fechaNueva,RedondeoValor,RedondeoValorCantRed,
filterComb (item, queryText, itemText) {
        const textOne = item.descripcion.toLowerCase()
        const textTwo = item.modulo.toLowerCase()
        const textTree = item.codnom.toLowerCase()
        const searchText = queryText.toLowerCase()
       // const hasValue = val => val != null ? val : ''
       //const text = hasValue(itemText)
        //const query = hasValue(queryText)

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1||
          textTree.indexOf(searchText) > -1
    },

    filterCombDocumento (item, queryText, itemText) {
        const textOne = item.nombre.toLowerCase()
        const textTwo = item.modulo.toLowerCase()
         const textTree = item.codnom.toLowerCase()
        const searchText = queryText.toLowerCase()
       // const hasValue = val => val != null ? val : ''
       //const text = hasValue(itemText)
        //const query = hasValue(queryText)

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1 ||
          textTree.indexOf(searchText) > -1
    },


onResize(e){

this.windowSize=e

},

    abrirTabla() {
      this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir;

    },
    async cargarTodo() {
      // await this.$axios
      //   .post(
      //     this.$hostname +
      //       this.$hName +
      //       "/services/tipocliente/findalltipoclientes",
      //     {
      //       usuario:JSON.parse(JSON.stringify(this.$user)) 
      //     }
      //   )
      //   .then(res => (this.ListaTiposClientes = res.data))
      //   .catch(error => console.log(error));
    },



CCuentasContables(e,t){

//this.acti_Modal_cuenta=b

// this.form.RLisCuenta= JSON.parse(JSON.stringify(e));
// this.form.TotalCuenta=JSON.parse(JSON.stringify(t)) 

this.RLisCuenta= JSON.parse(JSON.stringify(e));
//this.form.RLisCuenta= this.RLisCuenta

 this.TotalCuenta=JSON.parse(JSON.stringify(t)) 

},

calcularTotalcuenta(e){

  this.TotalCuenta.credito=0
  this.TotalCuenta.debito=0



 if(e.toString().length>0){
this.RLisCuenta.forEach(element => {
this.TotalCuenta.credito += element.credito
this.TotalCuenta.debito += element.debito   
});
}

},


obtenerDatoSelect(e){
this.datostabla(e.item)
},


    datostabla(e) {

this.selected=[]
this.selected.push(JSON.parse(JSON.stringify(e)))

var jsn=JSON.parse(JSON.stringify(e));
jsn.fecha=new Date(e.fecha).toISOString().substr(0,10)
delete jsn["contabilidadDetalleList"]
this.Utcontab=JSON.parse(JSON.stringify(jsn))
this.RLisCuenta=JSON.parse(JSON.stringify(e.contabilidadDetalleList))
this.calcularTotalcuenta(e.contabilidadDetalleList)

this.acti_tb_data=false


    },


GenerarContabilidad(){

if(this.UtilitarioContabBusqueda.documento==null){
  this.alerta("Seleccione un documento", "error") 
  return 0; 
}


if(this.UtilitarioContabBusqueda.operacion==null){
  this.alerta("Seleccione un operación", "error") 
  return 0; 
}

if(this.UtilitarioContabBusqueda.NoSecuencia==null || this.UtilitarioContabBusqueda.NoSecuencia!=null &&  this.UtilitarioContabBusqueda.NoSecuencia==0){
  this.alerta("digite una Secuencia", "error") 
  return 0; 
}

var OBJ_GC={
sec:this.UtilitarioContabBusqueda.NoSecuencia,
doc:this.UtilitarioContabBusqueda.documento.codigo,
ope:this.UtilitarioContabBusqueda.operacion.codigo
}

EventBus.$emit("loading", true) 
 this.$axios.post(
        this.$hostname + this.$hName + "/utilitarioContabilidad/GetContabilidad",
        OBJ_GC,
        { headers: this.$store.getters.GetheadersAxios },)
        .then((res) => {
          EventBus.$emit("loading", false) 

        if(res.data.length>0){
           var _this = this
            setTimeout(function() {
              _this.alerta("Dato generado correctamente!", "bien2")
              _this.TotalRegistros = res.data.length
              _this.ListContabilidad = res.data
             // _this.getContabilida();
              // setTimeout(function(){ _this.getContabilida()}, 5);
            }, 300)
          
         }else{
            this.alerta("Este documento no posee codificacion contable", "error")
         }

          // if (res.data.continuarDev == false) {
          //   this.alerta(res.data.mensage, res.data.estado)
          // }
        })
        .catch((error) => {
          EventBus.$emit("loading", false) 
          if (error.response) {
            this.alerta(error.response.request.responseText, "error")
          } else {  this.alerta(error, "error") }
        })


/*var _this=this;
this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioContabilidad/GetContabilidad', {
datos:JSON.parse(JSON.stringify(this.UtilitarioContabBusqueda))
})
.then(res=>{ 
  if(res.data.estado==true){this.alerta("Dato generado correctamente!", "bien"),setTimeout(function(){ _this.getContabilida()}, 5); }
  if(res.data.estado=="NoExist"){this.alerta("Dato contable no generado (Factura no existe)", "error")}
  if(res.data.estado=="NoSecDocOp"){this.alerta("El número de secuencia no existe en el documento y operación seleccionada", "error")}
  if(res.data.estado=="NoCodCont"){this.alerta("Este documento no posee codificación contable", "error")}
  if(res.data.estado==false){this.alerta("Dato contable no generado correctamente!", "error")}
      console.log('Resultado'), 
 console.log(res.data.estado) 
    })
 .catch(error =>{this.alerta("Dato no guardado"+error,"error")}); */


},

save() {
  
if (this.RedondeoValorCantRed((this.TotalCuenta.credito), 2) != this.RedondeoValorCantRed((this.TotalCuenta.debito), 2)) { 
  this.alerta("El total de debito y credito no coincide en el asiento contable", "error");
  return 0;
  }


  if (this.$refs.formContb.validate()) {
      EventBus.$emit("loading", true) 
        var Dato=this.Utcontab
        if(this.RLisCuenta.length>0){
        Dato.contabilidadDetalleList=this.RLisCuenta
        }else{Dato.contabilidadDetalleList=[]}

        this.$axios.post(this.$hostname + this.$hName + "/utilitarioContabilidad/saveOrUpdateContabilidad", Dato, {
                      headers: this.$store.getters.GetheadersAxios,
                    })
                    .then((res) => {
                      this.alerta("Dato guardado correctamente", "bien")
                     })
                    .catch((error) => {
                      this.alerta("Dato guardado correctamente", "error")
                    console.log("Dato no conectado.", error)
                    })
  
  }else{
  this.alerta("Los campos en rojo son requeridos", "error");
  }

    },

 eliminarContabilidad(item) {

var eliminar = confirm('Desea eliminar esta contabilidad?')
if(eliminar==true){
  EventBus.$emit("loading", true) 

   this.$axios.post(this.$hostname + this.$hName + "/utilitarioContabilidad/EliminarContabilidad", item, {
                      headers: this.$store.getters.GetheadersAxios,
                    })
                    .then((res) => {
                      this.alerta("Dato Eliminado correctamente", "bien")
                     })
                    .catch((error) => {
                      this.alerta("Dato Eliminado correctamente", "error")
                    console.log("Dato no conectado.", error)
                    })

}

},



    remove() {

if(this.Utcontab.id!=0 && this.Utcontab.id!=null){

      this.Elim_notif.estado = !this.Elim_notif.estado;
}else{ this.alerta("Seleccione un tipo de contabilidad para eliminar", "error")}


    },
    eliminar() {

  var jsn={
   datos:JSON.parse(JSON.stringify(this.Utcontab)),
   RLisCuenta:JSON.parse(JSON.stringify(this.RLisCuenta)),
   usuario:JSON.parse(JSON.stringify(this.$user)) 
  }

if (this.Utcontab!=0) {
        this.$axios
          .post(
            this.$hostname +
              this.$hName +
              "/services/utilitarioContabilidad/eliminarContabilidad",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => {this.alerta(res.data.mensage, res.data.estado)  })
          .catch(error =>
            this.alerta(
              // "hubo un error , por favor verifique el campo descripcion!"
              "Dato no eliminado"+error,
              "error"
            )
          );
      }


    },
    anular() {
      if (this.Elim_notif.estado) {

var jsn={
   datos:JSON.parse(JSON.stringify(this.UtilitarioContabBusqueda)),
   usuario:JSON.parse(JSON.stringify(this.$user)) 
  }

        this.$axios
          .post(
            this.$hostname +
              this.$hName +
              "/services/tipocliente/removeTipoCliente",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => this.alerta("Dato eliminado correctamente!", "bien"))
          .catch(error =>
            this.alerta(
              // "hubo un error , por favor verifique el campo descripcion!"
              "Dato no eliminado",
              "error"
            )
          );
      }
    },
    imprimirList() {

//console.log('Viendo la imprecion')





    },
    new() {

this.selected=[]

this.Utcontab={
id: 0,
activo:true,
comentario: "",
fecha: new Date().toISOString().substr(0,10),
operaciones: null,
referencia: "",
secuencia: 0,
descdocumento:""

},


this.UtilitarioContabBusqueda= {
   documento:null,
   fechaInicial: new Date().toISOString().substr(0,10),
   fechaFinal: new Date().toISOString().substr(0,10),
   NoSecuencia:0,
   operacion:null
      },

this.TotalCuenta={
          credito:0,
          debito:0
        }, 

        this.RLisCuenta=[],




this.ListContabilidad=[],

this.ejecucion=true

this.getContabilida()


    },

newwnuevo() {

  this.selected=[]

this.Utcontab={
id: 0,
activo:true,
comentario: "",
fecha: new Date().toISOString().substr(0,10),
operaciones: null,
referencia: "",
secuencia: 0,
descdocumento:""

},


this.UtilitarioContabBusqueda= {
   documento:null,
   fechaInicial: new Date().toISOString().substr(0,10),
   fechaFinal: new Date().toISOString().substr(0,10),
   NoSecuencia:0,
   operacion:null
      },

this.TotalCuenta={
          credito:0,
          debito:0
        }, 

        this.RLisCuenta=[],

this.ListContabilidad=[],
this.ejecucion=true

this.getContabilida()
        this.ejecucion = false
        EventBus.$emit("loading", false) 
        EventBus.$emit("actualizaBarraBusqueda2")
    },

NewReporte(){


this.dialogReporte=false


},


imprimiir(){

window.print()

},


Recalcular(){

//console.log('Recarculando')
//this.getPdf()

//this.dialogReporte=true

},


getPdf() {
  const pdff =
    "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";

  this.pdf= this.base64ToArrayBuffer(pdff);


},


base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
},



cargarDocumento(){
this.$axios.get(this.$hostname + this.$hName + "/utilitarioContabilidad/findalldocumento", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {this.RDocumento = res.data })
},


SelctCbDocumento(){
 var _this = this
      setTimeout(function() {
        if (_this.UtilitarioContabBusqueda.documento == null) {
          _this.UtilitarioContabBusqueda.documento = ""
        }

        if (!_this.UtilitarioContabBusqueda.documento.hasOwnProperty("codigo")) {
          _this.UtilitarioContabBusqueda.documento = ""
          _this.UtilitarioContabBusqueda.documento = null
          // _this.alerta("Seleccione un documento", "error");
          return
        }
        _this.getContabilida()

      }, 300)
},


CargarROperacion() {

this.$axios.get(this.$hostname + this.$hName + "/utilitarioContabilidad/findallOperacion", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {this.ROperacion = res.data })


    },


SelctCbOperacion() {
 var _this = this
      setTimeout(function() {
        if (_this.UtilitarioContabBusqueda.operacion == null) {
          _this.UtilitarioContabBusqueda.operacion = ""
        }

        if (!_this.UtilitarioContabBusqueda.operacion.hasOwnProperty("codigo")) {
          _this.UtilitarioContabBusqueda.operacion = ""
          _this.UtilitarioContabBusqueda.operacion = null
          // _this.alerta("Seleccione una operacion", "error");
          return
        }
      }, 300)

    },


    
resertPaginacion(){
this.resertPagi=false

//console.log('entrando al resert paginacion')

this.paginator.page=1
this.paginator.pageStart=0
this.paginator.pageStop=this.paginator.itemsPerPage

var _this=this;
setTimeout(function(){ _this.resertPagi=true  }, 500);

//setTimeout(this.resertPagi=true,1500);


// console.log('La paginacion')
// console.log(this.paginator)

},



cargarPaginacion(e) {
this.selected=[]
  // console.log('cargarPaginacion')
  //     console.log(e);
       this.paginator = e;

      if (this.paginator.itemsPerPage == -1) {
           this.paginator.itemsPerPage = 15;
         // this.paginator.itemsPerPage.push(15) 

      }

this.getContabilida()
   //   this.filtro();

    },





getContabilida(){

 
  
if(this.UtilitarioContabBusqueda.documento!=null && this.UtilitarioContabBusqueda.documento.hasOwnProperty('codigo') &&this.UtilitarioContabBusqueda.operacion==null && !this.UtilitarioContabBusqueda.operacion.hasOwnProperty('codigo')){
  return
}
//var obj = JSON.parse(JSON.stringify(this.ConsultaFacturas))
        // if (this.ConsultaFacturas.documento != null) {
        //   obj.documento = this.ConsultaFacturas.documento.codigo
        // }
        // if (this.ConsultaFacturas.cliente != null) {
        //   obj.cliente = this.ConsultaFacturas.cliente.codigo
        // }
        // obj.limit = this.paginator.itemsPerPage
        // obj.ultimo = this.paginator.pageStart
        
        var OBJ_GC={
              secuencia:this.UtilitarioContabBusqueda.NoSecuencia!=null && this.UtilitarioContabBusqueda.NoSecuencia>0?this.UtilitarioContabBusqueda.NoSecuencia:null,
              documento:this.UtilitarioContabBusqueda.documento!=null?this.UtilitarioContabBusqueda.documento.codigo:null,
              operacion:this.UtilitarioContabBusqueda.operacion!=null?this.UtilitarioContabBusqueda.operacion.codigo:null,
              fechaInicial:this.UtilitarioContabBusqueda.fechaInicial,
              fechaFinal:this.UtilitarioContabBusqueda.fechaFinal,
              limit:this.paginator.itemsPerPage,
              ultimo:this.paginator.pageStart
            }

        this.$axios.post(this.$hostname + this.$hName + "/utilitarioContabilidad/Listcontabilidad", OBJ_GC, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              // this.GetDataFact(res.data)
              ;(this.TotalRegistros = res.data.TbTotalItem), (this.ListContabilidad = res.data.ListContabilidad)
            })
            .catch((error) => {
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })





/*if (this.$refs.formContabilidad.validate()) {

this.$axios.post(this.$hostname + this.$hName + "/services/utilitarioContabilidad/Listcontabilidad", 
        {
          
           // descripcion:"",
            usuario:JSON.parse(JSON.stringify(this.$user)),
            datos:JSON.parse(JSON.stringify(this.UtilitarioContabBusqueda)),
            PrimerRegistro: this.paginator.pageStart,
            paginacion: this.paginator.page,
            cantidad: this.paginator.itemsPerPage,         
        })
        .then(res => {
         
          this.TotalRegistros = res.data.TotalRegistros, 
          this.ListContabilidad = res.data.ListContabilidad
          // console.log('Datos reporte '),
          // console.log(res.data)

        });

}else{
this.alerta("Los campos en rojo son requeridos", "error");
}*/


},


BlurfecInic() {
      if (this.UtilitarioContabBusqueda.fechaInicial.toString().length == 0) {
        this.UtilitarioContabBusqueda.fechaInicial = this.fechaNueva()
      }
    },

BlurfecFinal() {
      if (this.UtilitarioContabBusqueda.fechaFinal.toString().length == 0) {
        this.UtilitarioContabBusqueda.fechaFinal = this.fechaNueva()
      }
    },


    filterDocOperacion(RDocumento){
      if(this.UtilitarioContabBusqueda.operacion!=null && this.UtilitarioContabBusqueda.operacion.hasOwnProperty("codigo")){
       return  RDocumento.filter((ee) => ee.operacion != null && ee.operacion.codigo == this.UtilitarioContabBusqueda.operacion.codigo)
      }
      return RDocumento;
    },


    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
        this.newwnuevo();
      }

      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);
            EventBus.$emit("loading", false) 
             this.ejecucion = true;
      }
    },



//  FormatoFecha(params0) {
// var params= new Date(params0).toISOString().substr(0,10);
//       if (params != null) {
//         if (params.length > 0) {
//           return (
//             params.substring(8, 10) +
//             "-" +
//             params.substring(5, 7) +
//             "-" +
//             params.substring(0, 4)
//           );
//         }
//       }
//     },


// currencyFormatter(number) {
//       //return this.formatNumber(params) + ".00";
// if(number==null){number=0}
//       return number
//         .toFixed(2)
//         .toString()
//         .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");


//       ///return this.formatNumber(params);

//       //return params;
//     },

    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      // await this.$axios
      //   .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
      //     usuario:JSON.parse(JSON.stringify(this.$user)) 
      //   })
      //   .then(res => {
      //     this.list = res.data;
      //   });
    }
  },

  computed:{

    ActDescBtn(){

if(this.UtilitarioContabBusqueda.documento!=null && this.UtilitarioContabBusqueda.documento.hasOwnProperty('codigo') ){
this.disableOpera=true

if(this.UtilitarioContabBusqueda.documento.hasOwnProperty('operacion') && this.UtilitarioContabBusqueda.documento.operacion!=null){
  this.UtilitarioContabBusqueda.operacion= JSON.parse(JSON.stringify(this.UtilitarioContabBusqueda.documento.operacion))
}
}else{
this.disableOpera=false
}

/*this.EstadoBtn = {
              BarraTablaDinamicaAprir: true,
              nuevo: true,
              guardar: true,
              eliminar: true,
              anular: true,
              imprimir: true,
              vercuenta: false,
              guardartemporal: false,
              restaurartemporal: false,
              importarDato: false,
              cargarProducto: false,
              ImprimirproductoInv: false,
              etiquetaXfactura: false,
            };*/



if(this.Utcontab.id!=0){
  this.EstadoBtn = {
      BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: true,
            eliminar: false,
            anular: false,
            imprimir: false,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
            etiquetaXfactura: false,
    };

}else{

this.disableInp=false

this.EstadoBtn = {
          BarraTablaDinamicaAprir: false,
          nuevo:true ,
          guardar: false,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
          etiquetaXfactura: false,
        };
}
     
//EventBus.$emit("ActDesaBotones", objjct);



if(this.ListContabilidad.length==0){
this.Generarloading=false
}else{this.Generarloading=true}




    }
  }





};
</script>

<style>



#ImputColorDisable{
  color:black;
}





</style>
